import { Injectable, NgModule } from '@angular/core';
import { RouterModule, RouterStateSnapshot, Routes, TitleStrategy } from '@angular/router';
import { AccountComponent } from './pages/account/account.component';
import { ForbiddenComponent } from './pages/forbidden/forbidden.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { SubscriptionsComponent } from './pages/subscriptions/subscriptions.component';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';
import { ShellService } from './shell/services/shell.service';
import { IdentificationValidationComponent } from './pages/identification/identification-validation/identification-validation.component';
import { Title } from '@angular/platform-browser';
import { LicenseplateSettingsComponent } from './pages/settings/licenseplate-settings/licenseplate-settings.component';
import { PageTemplateComponent } from './pages/page-template/page-template.component';

@Injectable()
export class TemplatePageTitleStrategy extends TitleStrategy {
  constructor(private readonly title: Title) {
    super();
  }

  override updateTitle(routerState: RouterStateSnapshot) {
    const title = this.buildTitle(routerState);
    if (title !== undefined) {
      this.title.setTitle(`Parkbase9Gui - ${title}`);
    }
  }
}

export const routes: Routes = [
  { path: '', redirectTo: 'status/facilities', pathMatch: 'full' },
  { path: 'status', redirectTo: 'status/facilities', pathMatch: 'full' },
  ShellService.childRoutes([
    {
      path: 'status',
      title: 'Status page',
      loadChildren: () =>
        import('./pages/status-page/status-page.module').then((m) => m.StatusPageModule),
    },
  ]),
  ShellService.childRoutes([
    {
      path: 'identification/validation',
      component: IdentificationValidationComponent,
      title: 'identification validation',
    },
  ]),
  ShellService.childRoutes([
    {
      path: 'license-plate-settings',
      component: LicenseplateSettingsComponent,
      title: 'Licenseplate settings',
    },
  ]),
  ShellService.childRoutes([
    {
      path: 'transactions',
      title: 'transactions',
      loadChildren: () =>
        import('./pages/transactions/transactions.module').then((m) => m.TransactionsModule),
    },
  ]),
  ShellService.childRoutes([
    {
      path: 'settings',
      title: 'Application Settings',
      loadChildren: () =>
        import('./pages/settings/settings.module').then((m) => m.ApiSettingsModule),
    },
  ]),
  ShellService.childRoutes([{ path: 'profile', component: ProfileComponent, title: 'profile' }]),
  ShellService.childRoutes([
    { path: 'template', component: PageTemplateComponent, title: 'template' },
  ]),
  ShellService.childRoutes([
    { path: 'subscriptions', component: SubscriptionsComponent, title: 'subscriptions' },
  ]),
  { path: 'account', component: AccountComponent, title: 'account' },
  { path: 'account/logout', component: AccountComponent, title: 'account' },
  { path: 'forbidden', component: ForbiddenComponent, title: 'forbidden' },
  { path: 'unauthorized', component: UnauthorizedComponent, title: 'unauthorized' },
  { path: '**', component: NotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [
    {
      provide: TitleStrategy,
      useClass: TemplatePageTitleStrategy,
    },
  ],
})
export class AppRoutingModule {}
